<template>
	<div class="form-hp" aria-hidden="true">
		<label>
			Hagyja üresen / leave empty
			<input
					type="text"
					:name="HONEYPOT_FIELD"
					tabindex="-1"
					autocomplete="off"
					:value="modelValue"
					@input="emit('update:modelValue', ($event.target as HTMLInputElement).value)"
			>
		</label>
	</div>
</template>

<script setup lang="ts">
import {HONEYPOT_FIELD} from "../../Utils/FormProtection";

/**
 * The honeypot of the public forms: people do not see it (and are not sent to it by the keyboard), a robot fills it in.
 */
defineProps({
	modelValue: {
		type: String,
		default: '',
	},
});

const emit = defineEmits(['update:modelValue']);
</script>
